import React from 'react';
import PropTypes from 'prop-types';

import OutputText from '@ey/canvascoreservices/OutputText';

import MotifTooltip from '@ey/motif-react-wrapper/Tooltip';

const Tooltip = ({hideCloseButton = true, tooltipText = null, maxWidth = '300', children, ...rest}) => {
	const renderTooltipText = () => {
		const props = {
			wordBreak: true,
			maxWidth: `var(--px-${maxWidth})`
		};

		return <OutputText {...props}>{tooltipText}</OutputText>;
	};

	const props = {
		...rest,
		hideCloseButton,
		children: tooltipText !== null ? renderTooltipText() : children
	};

	return <MotifTooltip {...props} />;
};

Tooltip.propTypes = {
	hideCloseButton: PropTypes.bool,
	tooltipText: PropTypes.string,
	maxWidth: PropTypes.string
};

export default Tooltip;
